// removed by extract-text-webpack-plugin
module.exports = {"arrow":"arrow__7yEJh","main":"main__1gyD0"};


//////////////////
// WEBPACK FOOTER
// ./components/main/style.css
// module id = STmO
// module chunks = 2